export default "__VITE_ASSET__yyMLfEv4__"